var _path, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon3DViewNoCube = function SvgIcon3DViewNoCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "3D view",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 35.993 35.379"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon material-crop-rotate",
    d: "M11.789 29.452a14.433 14.433 0 0 1-8.182-11.636H1.551a16.438 16.438 0 0 0 16.377 15.076c.315 0 .6-.027.9-.041l-5.217-5.236ZM18.065 0c-.315 0-.6.027-.9.055l5.222 5.222 1.823-1.823a14.392 14.392 0 0 1 8.182 11.622h2.056A16.438 16.438 0 0 0 18.065 0Z",
    fill: "#1f1f1f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "3D",
    transform: "translate(7.05 21.344)",
    fill: "#1f1f1f",
    fontSize: 16,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3D"))));
};
export default SvgIcon3DViewNoCube;